const splitSkillMarkdown = (content: string) => {
  const opening = content.match(/^---[ \t]*\r?\n/);
  if (!opening) return { frontmatter: '', body: content };

  const closing = /^---[ \t]*(?:\r?\n|$)/m.exec(content.slice(opening[0].length));
  if (!closing) return { frontmatter: '', body: content };

  const bodyStart = opening[0].length + closing.index + closing[0].length;
  return { frontmatter: content.slice(0, bodyStart), body: content.slice(bodyStart) };
};

const needsMarkdownSource = (content: string) => {
  const prose = content.replace(/^ {0,3}(`{3,}|~{3,})[^\n]*\n[\s\S]*?^ {0,3}\1[ \t]*$/gm, '').replace(/`[^`\n]*`/g, '');
  // <u> is what the editor itself writes for underline, so it round-trips and is not foreign HTML.
  return /^ {0,3}#{4,6}\s/m.test(prose) || /!\[|<\/?(?!u>)[a-z]|<!--/i.test(prose);
};

const joinSkillMarkdown = (frontmatter: string, body: string) =>
  frontmatter && body && !frontmatter.endsWith('\n') ? `${frontmatter}\n${body}` : frontmatter + body;

const DESCRIPTION = /^description:[ \t]*(.*(?:\r?\n[ \t]+.*)*)(?:\r?\n)?/m;

const readDescription = (frontmatter: string) => {
  const value =
    frontmatter
      .match(DESCRIPTION)?.[1]
      .replace(/^[|>][+-]?/, '')
      .trim() ?? '';
  if (value.startsWith('"')) {
    try {
      return JSON.parse(value) as string;
    } catch {}
  }
  return value.replace(/^'([\s\S]*)'$/, '$1').replace(/\s*\r?\n\s*/g, ' ');
};

const writeDescription = (frontmatter: string, description: string) => {
  const value = description.replace(/\s+/g, ' ').trim();
  // Quoted whenever YAML could read the text as something else, such as a colon starting a nested key.
  const line = value ? `description: ${/[:#]|^[^A-Za-z0-9(]/.test(value) ? JSON.stringify(value) : value}\n` : '';
  if (!frontmatter) return line && `---\n${line}---\n`;
  if (DESCRIPTION.test(frontmatter)) return frontmatter.replace(DESCRIPTION, line);
  const closing = frontmatter.lastIndexOf('---');
  return frontmatter.slice(0, closing) + line + frontmatter.slice(closing);
};

export { joinSkillMarkdown, needsMarkdownSource, readDescription, splitSkillMarkdown, writeDescription };
